import SEOHead from "@/components/SEOHead";
import HeroSection from "@/components/HeroSection";
import FeaturedProducts from "@/components/FeaturedProducts";
import LimitedDropBanner from "@/components/LimitedDropBanner";
import MarketingBanner from "@/components/MarketingBanner";
import ReviewsSection from "@/components/ReviewsSection";
import Newsletter from "@/components/Newsletter";
import AIRecommendations from "@/components/AIRecommendations";

const Index = () => {
  const homepageJsonLd = [
    {
      "@type": "WebPage",
      "name": "Gonvex — Your World, Under Absolute Command",
      "description": "Shop premium Gen Z streetwear at Gonvex. Futuristic designs, anime-inspired drops, bold oversized tees, hoodies & accessories. Free shipping on orders over ₹999.",
      "url": "https://gonvexgears.in/",
      "speakable": {
        "@type": "SpeakableSpecification",
        "cssSelector": ["h1", ".hero-description"],
      },
    },
    {
      "@type": "BreadcrumbList",
      "itemListElement": [
        { "@type": "ListItem", "position": 1, "name": "Home", "item": "https://gonvexgears.in/" },
      ],
    },
    {
      "@type": "ClothingStore",
      "name": "Gonvex",
      "url": "https://gonvexgears.in",
      "priceRange": "₹₹",
      "description": "Premium Gen Z streetwear — oversized tees, hoodies, anime-inspired drops. Free shipping above ₹999.",
      "paymentAccepted": "UPI, Credit Card, Debit Card, Net Banking, Cash on Delivery",
      "currenciesAccepted": "INR",
    },
  ];

  return (
  <div className="relative">
    <SEOHead canonical="/" jsonLd={homepageJsonLd} />
    <HeroSection />
    <div className="relative">
      <FeaturedProducts />
      <AIRecommendations />
      <MarketingBanner />
      <LimitedDropBanner />
      <ReviewsSection />
      <Newsletter />
    </div>
  </div>
  );
};

export default Index;